import React, { useContext } from "react";
import { createPortal } from "react-dom";

import { FlyoutFooterContext } from "./flyoutFooterContext";

/**
 * Actions rendered in the flyout's footer.
 */
const FlyoutFooterActions: React.FC<React.PropsWithChildren> = ({ children }) => {
  const footer = useContext(FlyoutFooterContext);
  return footer ? createPortal(children, footer) : null;
};

export default FlyoutFooterActions;
